var map = {
	"./head.png": "b62d",
	"./head1.png": "7c62",
	"./head2.png": "f7f9",
	"./head3.png": "6ceb",
	"./head4.png": "6e7f",
	"./head5.png": "f88e",
	"./head@2x.png": "691a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "13c1";